import { callExternalApi } from "./external-api.service";

const apiServerUrl = import.meta.env.VITE_API_SERVER_URL;

export const postFile = async (accessToken: string, fileData: any | null) => {
    const config = {
        url: `${apiServerUrl}/api/upload`,
        method: "POST",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`,
        },
        data: fileData,
        timeout: 300000, // 5 minutes
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
};

export const pingApi = async (accessToken: string) => {
    const config = {
        url: `${apiServerUrl}/api/ping`,
        method: "GET",
        headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${accessToken}`,
        },
    };

    const { data, error } = await callExternalApi({ config });

    return {
        data: data || null,
        error,
    };
}
